"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _JsonFetch = require("./../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (serverContextPath === null) {
    console.error("Global variable serverContextPath is not defined (is null)!");
}

var EprApi = function () {
    function EprApi() {
        (0, _classCallCheck3.default)(this, EprApi);
    }

    (0, _createClass3.default)(EprApi, null, [{
        key: "findTypyPrestupku",
        value: function findTypyPrestupku() {
            var recidiva = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(EprApi.typy, { recidiva: recidiva }));
        }
    }]);
    return EprApi;
}();

EprApi.baseUrl = serverContextPath + "/api";
EprApi.epr = EprApi.baseUrl + '/prestupky';
EprApi.typy = EprApi.epr + '/typy';
exports.default = EprApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYXBpL0VwckFwaS5qc3giXSwibmFtZXMiOlsic2VydmVyQ29udGV4dFBhdGgiLCJjb25zb2xlIiwiZXJyb3IiLCJFcHJBcGkiLCJyZWNpZGl2YSIsIkVycm9yQXBpIiwicmVzcG9uc2VSZXNvbHZlciIsIkpzb25GZXRjaCIsImdldCIsInR5cHkiLCJiYXNlVXJsIiwiZXByIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQUlBLHNCQUFzQixJQUExQixFQUFnQztBQUM1QkMsWUFBUUMsS0FBUixDQUFjLDZEQUFkO0FBQ0g7O0lBRW9CQyxNOzs7Ozs7OzRDQU15QjtBQUFBLGdCQUFqQkMsUUFBaUIsdUVBQU4sSUFBTTs7QUFDdEMsbUJBQU9DLG1CQUFTQyxnQkFBVCxDQUEwQkMsb0JBQVVDLEdBQVYsQ0FBY0wsT0FBT00sSUFBckIsRUFBMkIsRUFBQ0wsVUFBVUEsUUFBWCxFQUEzQixDQUExQixDQUFQO0FBQ0g7Ozs7O0FBUmdCRCxNLENBQ1ZPLE8sR0FBd0JWLGlCO0FBRGRHLE0sQ0FFVlEsRyxHQUFxQlIsT0FBT08sT0FBUCxHQUFpQixZO0FBRjVCUCxNLENBSVZNLEksR0FBcUJOLE9BQU9RLEdBQVAsR0FBYSxPO2tCQUp4QlIsTSIsImZpbGUiOiJFcHJBcGkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRXJyb3JBcGkgZnJvbSBcIi4vLi4vdXRpbHMvRXJyb3JBcGlcIlxuaW1wb3J0IEpzb25GZXRjaCBmcm9tIFwiLi8uLi91dGlscy9Kc29uRmV0Y2hcIlxuXG5pZiAoc2VydmVyQ29udGV4dFBhdGggPT09IG51bGwpIHtcbiAgICBjb25zb2xlLmVycm9yKFwiR2xvYmFsIHZhcmlhYmxlIHNlcnZlckNvbnRleHRQYXRoIGlzIG5vdCBkZWZpbmVkIChpcyBudWxsKSFcIik7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEVwckFwaSB7XG4gICAgc3RhdGljIGJhc2VVcmwgPSAgICAgICAgICAgIGAke3NlcnZlckNvbnRleHRQYXRofS9hcGlgO1xuICAgIHN0YXRpYyBlcHIgPSAgICAgICAgICAgICAgICBFcHJBcGkuYmFzZVVybCArICcvcHJlc3R1cGt5JztcblxuICAgIHN0YXRpYyB0eXB5ID0gICAgICAgICAgICAgICBFcHJBcGkuZXByICsgJy90eXB5JztcblxuICAgIHN0YXRpYyBmaW5kVHlweVByZXN0dXBrdShyZWNpZGl2YSA9IG51bGwpIHtcbiAgICAgICAgcmV0dXJuIEVycm9yQXBpLnJlc3BvbnNlUmVzb2x2ZXIoSnNvbkZldGNoLmdldChFcHJBcGkudHlweSwge3JlY2lkaXZhOiByZWNpZGl2YX0pKTtcbiAgICB9XG59XG4iXX0=